import { render } from "./Payment.vue?vue&type=template&id=fff2569a"
const script = {}
script.render = render

export default script